export default "__VITE_ASSET__DKJ$ASgO__"